<template>
  <div style="padding: 20px;" v-if="userinfo.isAdmin == true">
    <a href="/admin">Admin home</a> | 
    <a href="/adminpages">Pages</a> | 
    <a href="/adminorders">Orders</a> | 
    <a href="/adminvip">VIP</a>
    <hr> 
    <a href="#" @click.prevent="toggle = false">All</a> | 
    <a href="#" @click.prevent="toggle = true, toggleActive = true">Active</a> | 
    <a href="#" @click.prevent="toggle = true, toggleActive = false">Inactive</a>
    <transition name="fade">
        <alert-bar v-if="msgtext" v-bind:class="msgclass">{{msgtext}}</alert-bar>
      </transition>
    <table>
      <thead>
        <th>
          Websiteid
        </th>
        <th>
          Name
        </th>
        <th>
          Wants to buy
        </th>
        <th>
          Give info on
        </th>
        <th>
          Contact by
        </th>
        <th>
          Info
        </th>
        <th>
          Active
        </th>
        <th>
          Activate
        </th>
        <th>
          Settings
        </th>
        <th>
          Delete?
        </th>
      </thead>
      <tbody>
        <tr v-for="setting in settings" v-if="setting.isactive == toggleActive || toggle == false">
          <td>
            <a :href="'/creator/'+setting.websiteid" target="_blank">{{setting.websiteid}}</a>
          </td>
          <td>
            {{ setting.name }}
          </td>
          <td>
            <span v-for="info in setting.orderinfo"> {{ info.request }} </span>
          </td>
          <td>
            <span v-for="info in setting.orderinfo"> {{ info.infoneeded }} </span>
          </td>
          <td>
            <span v-for="info in setting.orderinfo"> {{ info.contactby }} </span>
          </td>
          <td>
            <span v-for="info in setting.orderinfo"> {{ info.phonenumber }} {{ info.email }}</span>
          </td>
          <td :style="[setting.isactive == true ? {'background-color': '#00C300', 'color': 'white','font-weight': 'bold', 'text-transform': 'uppercase'} : {}]">
            <span>
              {{ setting.isactive }}
            </span>
          </td>
          <td>
            <button v-if="setting.isactive == false" @click.prevent="showModal = true, activateWebsiteID = setting.websiteid, activateWebsiteStatus = !setting.isactive">
              Activate
            </button>
            <button v-else @click.prevent="showModal = true, activateWebsiteID = setting.websiteid, activateWebsiteStatus = !setting.isactive">
              Deactivate
            </button>
          </td>
          <td style="white-space: nowrap; max-width: 300px; overflow: auto;">
            <a :href="'http://api.phabsite.com/settings/'+setting.websiteid" target="_blank">[view]</a>
            {{setting.settings}}
          </td>
          <td>
            <button style="background: red; color: #fff; border: 0;" @click.prevent="showModalDelete = true, selectedwebsiteid = setting.websiteid">Remove</button>
          </td>
        </tr>
      </tbody>
    </table>

    <modal v-if="showModal" @close="showModal = false" title="Activate">
        <form @click.prevent="activateSite(activateWebsiteID, activateWebsiteStatus)">
            <p>Weet je zeker dat je deze website wil ACTIVEREN?</p>
            <button class="button" type="submit">Ja, ik weet het zeker</button>
        </form>
    </modal>

    <modal v-if="showModalDelete" @close="showModalDelete = false" title="Delete site and users">
        <form @click.prevent="removeUser()">
            <p>Weet je zeker dat je deze website wil verwijderen?</p>
            <button class="button" type="submit">Ja, ik weet het zeker</button>
        </form>
    </modal>
  </div>
</template>

<script>
  import InputDefault from '../components/form/InputDefault.vue';
  import Modal from '../components/modal/Modal.vue';
  import AlertBar from '../components/form/Alert.vue';
  import Loader from '../components/ui/Loader.vue';
  import MainNav from '../components/navigation/MainNav.vue';
  import HomeBlock from '../components/content/HomeBlock.vue';

  import { userService } from '../services/user.service.js';
  import { authHeader } from '../services/auth-header.js';
  
  import axios from 'axios';

  export default {
    props:{
    },
    data: function (){
      return {
        toggle: false,
        toggleActive: true,
        showModal: false,
        showModalDelete: false,
        msgtext: '',
        msgclass: 'error',
        username: '',
        password: '',
        submitted: false,
        loading: false,
        loggingin: false,
        returnUrl: '',
        activateWebsiteID: '',
        activateWebsiteStatus: '',
        selectedwebsiteid: '',
        error: '',
        settings: {},
        pages: {},
        userinfo: JSON.parse(localStorage.getItem('user'))
      }
    },
    created () {
    },
    components: {
      InputDefault,
      AlertBar,
      Loader,
      MainNav,
      HomeBlock,
      Modal
    },
    methods: {
        getSettings(){
            const requestOptions = {
              headers: authHeader()
            }

            axios.get(process.env.VUE_APP_ROOT_API+'/settings/', requestOptions)
            .then(response => {
                console.log(response)
                this.settings = response.data.response
            })
        },
        activateSite(siteid, activate){
          const requestOptions = {
              headers: authHeader()
          }

          const data = {
              websiteid: siteid,
              dbentry: 'isactive',
              content: activate
          }

          axios.patch(process.env.VUE_APP_ROOT_API+'/settings/', data, requestOptions)
          .then(response => {
              this.getSettings();
              this.showModal = false;
          })
        },
        removeUser(){
            const requestOptions = {
              headers: authHeader()
            }

            axios.delete(process.env.VUE_APP_ROOT_API+'/users/'+this.selectedwebsiteid, requestOptions)
            .then(response => {
                this.msgtext = this.selectedwebsiteid +' has been deleted'
                this.getSettings();
                this.showModalDelete = false
            })
        }
    },
    mounted(){
        this.getSettings()
    }
  }
</script>

<style lang="scss" scoped>
  table{
    border-collapse: collapse;

    th, td{
      padding: 10px 20px;
      border: 1px solid #ccc;
    }

    th{
      color: #666;
      text-transform: uppercase;
      font-weight: normal;
      font-size: .8rem;
    }
  }
</style>
